/* tslint:disable */
/* eslint-disable */
/**
 * partnerDriverWeb driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const DriverRegistrationLogStatus = {
        IN_PROGRESS: 'in_progress',
        SUBMITTED: 'submitted',
        ONBOARDING: 'onboarding',
        DECLINED: 'declined',
        DECLINED_SILENTLY: 'declined_silently',
        ACCEPTED: 'accepted',
        DOCUMENTS_NEED_RESUBMISSION: 'documents_need_resubmission',
        DOCUMENTS_RESUBMITTED: 'documents_resubmitted',
        DELETED: 'deleted',
        PENDING_COMPANY_APPROVAL: 'pending_company_approval'
} as const;
export type DriverRegistrationLogStatus = typeof DriverRegistrationLogStatus[keyof typeof DriverRegistrationLogStatus];

